export async function GetAllCandidates(parameters) {
  const filteredParams = Object.fromEntries(
    Object.entries(parameters).filter(
      ([_, value]) => value !== null && value !== ""
    )
  );
  const params = new URLSearchParams(filteredParams);
  const queryString = params.toString();
  const response = await fetch(
    `${process.env.REACT_APP_API}/api/candidate/all?${queryString}`,
    {
      method: "GET",
    }
  );

  const data = await response.json();
  if (!data.success) {
    throw new Error(data.Errors[0]);
  }

  return data; // Return the response data
}

export async function GetVideo(parameters) {
  const filteredParams = Object.fromEntries(
    Object.entries(parameters).filter(
      ([_, value]) => value !== null && value !== ""
    )
  );
  const params = new URLSearchParams(filteredParams);
  const queryString = params.toString();
  const response = await fetch(
    `${process.env.REACT_APP_API}/api/video/download?${queryString}`,
    {
      method: "GET",
    }
  );

  const data = await response.json();

  return data; // Return the response data
}
